import { render, staticRenderFns } from "./CollegeCleanupAdminPage.vue?vue&type=template&id=685e06ff&scoped=true&"
import script from "./CollegeCleanupAdminPage.vue?vue&type=script&lang=js&"
export * from "./CollegeCleanupAdminPage.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCleanupAdminPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CollegeCleanupAdminPage.vue?vue&type=style&index=1&id=685e06ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e06ff",
  null
  
)

export default component.exports